import Swiper from 'swiper';
import { Pagination, Navigation } from 'swiper/modules';

export default () => {
    const nodeSelectors = {
        associationsSlider: '[js-associations-slider="slider"]',
        prevButton: '[js-associations-slider="prev"]',
        nextButton: '[js-associations-slider="next"]'
    }

    function init() {
        if (!document.querySelector(nodeSelectors.associationsSlider)) {
            return
        }

        initassociationsSlider()
    }

    function initassociationsSlider() {
    

        const associationsSlider = new Swiper(nodeSelectors.associationsSlider, {
            modules: [Pagination, Navigation],
            slidesPerView: 1,
            loop: true,
            navigation: {
                prevEl: nodeSelectors.prevButton,
                nextEl: nodeSelectors.nextButton,
            },
            breakpoints: {
                750: {
                    slidesPerView: 3,
                    spaceBetween: 10,
                    loop: true
                }
            }
        });        
    }

    return Object.freeze({
        init,
    })
}